import { VuexModule, Module, MutationAction, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';
import { RouteConfig } from 'vue-router';


/**
 *  页签状态定义
 *
 * @export
 * @interface ITagsViewState
 */
export interface ITagsViewState {
  visitedViews: RouteConfig[];    // 访问过的状态
  cachedViews: string[];     // 缓存的状态
}



/**
 * 标签管理模块
 *
 * @class TagsView
 * @extends {VuexModule}
 * @implements {ITagsViewState}
 */
@Module({ dynamic: true, store, name: 'tagsView' })
class TagsView extends VuexModule implements ITagsViewState {

  public   visitedViews: RouteConfig[] = [];
  public   cachedViews: string[] = [];

  @Action
  public async  addView(view: RouteConfig) {
    this.context.dispatch('addVisitedView', view);
    this.context.dispatch('addCachedView', view);
  }

  @Action({ commit: 'ADD_VISITED_VIEW' })
  public async addVisitedView(view: RouteConfig) {
    return view;
  }
  @Action({ commit: 'ADD_CACHED_VIEW' })
  public async addCachedView(view: RouteConfig) {
    return view;
  }

  @Action
  public async  delView(view: RouteConfig) {
    await this.context.dispatch('delVisitedView', view);
    await this.context.dispatch('delCachedView', view);
    return {
      visitedViews: [...this.visitedViews],
      cachedViews: [...this.cachedViews],
    };
  }
  @Action
  public async   delVisitedView(view: RouteConfig) {
    this.context. commit('DEL_VISITED_VIEW', view);
    return [...this.visitedViews];
    }
    @Action
    public async   delCachedView( view: RouteConfig) {

      this.context.commit('DEL_CACHED_VIEW', view);
      return [...this.visitedViews];
    }
    @Action
    public async   delOthersViews(view: RouteConfig) {
      await this.context.dispatch('delOthersVisitedViews', view);
      await  this.context. dispatch('delOthersCachedViews', view);
      return {
        visitedViews: [...this.visitedViews],
        cachedViews: [...this.cachedViews],
      };
    }
    @Action
    public async  delOthersVisitedViews( view: RouteConfig) {
      this.context.commit('DEL_OTHERS_VISITED_VIEWS', view);
      return [...this.visitedViews];
    }
    @Action
    public async delOthersCachedViews( view: RouteConfig) {
      this.context.commit('DEL_OTHERS_CACHED_VIEWS', view);
      return [...this.cachedViews];
    }
    @Action
    public async  delAllViews(view: RouteConfig) {
      await this.context.dispatch('delAllVisitedViews', view);
      await  this.context.dispatch('delAllCachedViews', view);
      return {
        visitedViews: [...this.visitedViews],
        cachedViews: [...this.cachedViews],
      };
    }

    @Action
    public async  delAllVisitedViews() {
      this.context.commit('DEL_ALL_VISITED_VIEWS');
      return [...this.visitedViews];
    }
    @Action
    public async delAllCachedViews() {
      this.context.commit('DEL_ALL_CACHED_VIEWS');
      return [...this.cachedViews];
    }

    @Action({ commit: 'UPDATE_VISITED_VIEW' })
    public async updateVisitedView(view: RouteConfig) {
      return view;
    }


  /**
   * 添加访问过的页面
   *
   * @private
   * @param {RouteConfig} view
   * @returns
   * @memberof TagsView
   */
  @Mutation
  private  ADD_VISITED_VIEW( view: RouteConfig) {
      if (this.visitedViews.some((v) => v.path === view.path)) { return; }
      this.visitedViews.push(
        Object.assign({}, view, {
          title: view.meta.title || 'no-name',
        }),
      );
    }

  /**
   *  添加缓存页面
   *
   * @private
   * @param {RouteConfig} view
   * @returns
   * @memberof TagsView
   */
  @Mutation
  private ADD_CACHED_VIEW(view: RouteConfig) {
    if (!view.name || this.cachedViews.includes(view.name)) { return; }
    if (!view.meta.noCache) {
      this.cachedViews.push(view.name);
    }
  }

  @Mutation
  private DEL_VISITED_VIEW(view: RouteConfig) {
    for (const [i, v] of this.visitedViews.entries()) {
      if (v.path === view.path) {
        this.visitedViews.splice(i, 1);
        break;
      }
    }
  }
  @Mutation
  private DEL_CACHED_VIEW(view: RouteConfig) {
    for (const i of this.cachedViews) {
      if (i === view.name) {
        const index = this.cachedViews.indexOf(i);
        this.cachedViews.splice(index, 1);
        break;
      }
    }
  }

  @Mutation
  private DEL_OTHERS_VISITED_VIEWS(view: RouteConfig) {
    this.visitedViews = this.visitedViews.filter((v) => {
      return v.meta.affix || v.path === view.path;
    });
  }

  @Mutation
  private DEL_OTHERS_CACHED_VIEWS(view: RouteConfig) {
    for (const i of this.cachedViews) {
      if (i === view.name) {
        const index = this.cachedViews.indexOf(i);
        this.cachedViews = this.cachedViews.slice(index, index + 1);
        break;
      }
    }
  }

  @Mutation
  private DEL_ALL_VISITED_VIEWS() {
    // keep affix tags
    const affixTags = this.visitedViews.filter((tag) => tag.meta.affix);
    this.visitedViews = affixTags;
  }

  @Mutation
  private DEL_ALL_CACHED_VIEWS() {
    this.cachedViews = [];
  }

  @Mutation
  private UPDATE_VISITED_VIEW(view: RouteConfig) {
    for (let v of this.visitedViews) {
      if (v.path === view.path) {
        v = Object.assign(v, view);
        break;
      }
    }
  }
}

export const TagsViewModule = getModule(TagsView);
